<template>
    <div class="container-main">
        <div class="d-flex justify-space-between">
            <div class="container-main-header-button">
                <v-btn depressed @click="back">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <span>Создание блока</span>
            </div>
            <div>


            </div>
        </div>

        <div class="container-block">
            <v-form ref="formFirst">
                <div>
                    <v-text-field label="Название" required type="text" :rules="rules" outlined
                        v-model="activity.title"></v-text-field>
                </div>
            </v-form>
        </div>
        <div class="container-block">
            <div class="container-block-title">
                Вид перехода из блока
            </div>
            <v-radio-group mandatory v-model="transitionType" row>

                <v-radio color="var(--app-dark-blue-1)" label="Ссылка" value="url"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Внутренний раздел" value="deeplink"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Файл" value="file"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Событие" value="event"></v-radio>
            </v-radio-group>
            <div v-if="transitionType == 'url'">
                <v-form lazy-validation ref="formLink">

                    <v-text-field label="Ссылка" required type="text" outlined :rules="[
                        v => !!v || 'Обязательно к заполнению',
                        v => checkValidUrl(v) || '',
                    ]" v-model="activity.path"></v-text-field>

                    <v-checkbox class="container-main-checkbox pt-5" color="var(--app-dark-blue-1)"
                        v-model="activity.isWebView"
                        label="Открыть WebView (ссылка откроется внутри приложения)"></v-checkbox>


                </v-form>
            </div>
            <div v-if="transitionType == 'deeplink'">
                <v-form lazy-validation ref="formDeepLink">


                    <v-select :items="sections" outlined item-text="name" item-value="key"
                        :rules="[v => !!(v && v.length) || 'Обязательно к заполнению']" v-model="activity.appSectionKey"
                        label="Выберите раздел для перехода"></v-select>

                </v-form>
            </div>

            <div v-if="transitionType == 'file'">
                <v-form lazy-validation ref="formPDF">
                    <v-file-input outlined show-size v-model="activity.transitionFile" label="Прикрепите файл pdf"
                        :rules="[value => (value && value.size < 104857600) || 'Размер pdf не больше 100 мб']"
                        hint="Максимальный размер pdf 100 Мб" persistent-hint
                        accept="application/pdf,application/vnd.ms-excel"> </v-file-input>


                </v-form>
            </div>
            <div v-if="transitionType == 'event'">
                <v-form lazy-validation ref="formEvent">
                    <v-select :items="events" outlined item-text="name" item-value="id" :rules="rules"
                        v-model="activity.path" label="Выберите событие"></v-select>
                </v-form>
            </div>
        </div>


        <div v-if="!newImage" class="container-block">
            <div class="container-block-title">
                Изображение
            </div>

            <v-file-input accept="image/*" outlined
                :rules="[value => (value && value.size < 104857600) || 'Размер изображения не больше 100 мб']"
                hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
                label="Прикрепить изображение"></v-file-input>
            <div class="container-block-gallery-button">
                Выбрать изображение из галереи
            </div>

        </div>


        <div v-if="newImage" class="container-block" style="width: 100%">
            <div class="container-block-title">
                Кадрировать изображение
            </div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Формат
                            </th>
                            <th class="text-left">
                                Место отображенния
                            </th>
                            <th class="text-left">
                                Для смартфонов
                            </th>
                            <th class="text-left">
                                Для планшетов
                            </th>
                            <th class="text-right">

                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr style="height: 60px;" v-if="newImage">
                            <td class="text-left">Иконка блока</td>
                            <td class="text-left">Изображение на фоне блока</td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>

                                <div v-else class="d-flex">
                                    <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile">
                                    <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>

                            </td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>
                                <div v-else class="d-flex">
                                    <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet">
                                    <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>


                            </td>
                            <td class="text-left">
                                <v-btn icon @click="deleteImage">
                                    <v-icon color="var(--app-red-1)">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>

                            </td>
                        </tr>




                    </tbody>
                </template>
            </v-simple-table>
            <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
                Откадрируйте изображения для всех типов устройств


            </v-alert>
            <v-divider></v-divider>



            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogMobile = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на мобильном устройстве
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="d-flex justify-space-between">
                            <div style="width: 380px;  height: 380px;">
                                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px;  height: 450px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 164,
    height: 168
}" image-restriction="stencil" @change="onChangeMobile" />
                            </div>


                            <div style="width: 100%;" class="d-flex justify-center" v-if="resultImageMobile">
                                <img width="164px" height="168px" :src="resultImageMobile">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeMobileImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>



            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogTablet = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на планшете
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="">

                            <div style="width: 100%;   height: 200px;">
                                <cropper ref="cropperTablet" :src="imgSrc" style="width: 100%;   height: 300px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 280,
    height: 168
}" image-restriction="stencil" @change="onChangeTablet" />
                            </div>

                            <div class="dialog-tablet-img" v-if="resultImageTablet">
                                <img width="280px" height="168px" :src="resultImageTablet">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeTabletImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>



        </div>
        <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
            Прикрепите изображение

        </v-alert>

        <div class="container-block-footer-buttons">
            <div>
                <v-btn @click="saveActivity" style="width: auto !important" class="button-accept">
                    Сохранить
                </v-btn>

            </div>

        </div>



    </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
    components: {
        Cropper
    },
    data: () => ({
        activity: { isWebView: false, },

        errImages: false,
        errImagesMain: false,
        dialogMobile: false,

        dialogTablet: false,

        transitionType: '',
        sections: [],
        events: [],


        rules: [value => !!value || 'Обязательно к заполнению'],

        newImage: null,
        imgSrc: '',

        resultImageMobile: '',
        resultImageTablet: '',

        finishImageMobile: '',
        finishImageTablet: '',

        smartphoneMainImage: null,
        tabletMainImage: null,

        files: [{ name: '', value: null }],
        formData: new FormData(),

    }),


    methods: {
        getAppSections() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/appSection/list', {},
                {
                    headers: {
                        'authorization': this.$store.getters.adminPanelHeaderAuth
                    }
                })
                .then(res => {

                    this.sections = res.data.items.filter(i => {
                        if (!i.isRemovable) {
                            return i
                        }
                    })

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },



        deleteImage() {
            this.newImage = null
            this.imgSrc = ''
            this.resultImageMobile = ''
            this.resultImageTablet = ''
            this.finishImageMobile = ''
            this.finishImageTablet = ''
            this.smartphoneMainImage = null
            this.tabletMainImage = null


        },

        openMobileImg() {


            this.dialogMobile = true
            setTimeout(() => {
                this.$refs.cropperMobail.refresh()
            }, 500)


            this.errImages = false
        },
        openTabletImg() {


            this.dialogTablet = true
            setTimeout(() => {
                this.$refs.cropperTablet.refresh()
            }, 500)


            this.errImages = false
        },
        closeTabletImg() {

            this.finishImageTablet = this.resultImageTablet
            this.dialogTablet = false
            const { canvas } = this.$refs.cropperTablet.getResult();

            canvas.toBlob(blob => {
                this.formData.append('tabletImage', blob);

            }, 'image/webp', 0.95);
            this.tabletMainImage = true

        },

        closeMobileImg() {

            this.finishImageMobile = this.resultImageMobile
            this.dialogMobile = false
            const { canvas } = this.$refs.cropperMobail.getResult();
            canvas.toBlob(blob => {
                this.formData.append('smartphoneImage', blob);

            }, 'image/webp', 0.95);
            this.smartphoneMainImage = true


        },

        back() {
            this.$router.push({ name: 'DetailFolderOther', params: { id: this.$route.params.id } })

        },


        previewImage() {

            if (this.newImage) {

                this.imgSrc = URL.createObjectURL(this.newImage)
            }
            else {
                this.imgSrc = ''
            }
        },



        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },


        onChangeMobile({ canvas }) {
            this.resultImageMobile = canvas.toDataURL()
        },

        onChangeTablet({ canvas }) {
            this.resultImageTablet = canvas.toDataURL()


        },


        saveActivity() {
            if (this.$refs.formFirst.validate()) {
                let formType = null
                if (this.transitionType == 'url') { formType = this.$refs.formLink }
                else if (this.transitionType == 'deeplink') { formType = this.$refs.formDeepLink }
                else if (this.transitionType == 'file') { formType = this.$refs.formPDF }
                else if (this.transitionType == 'event') { formType = this.$refs.formEvent }
                if (formType.validate()) {

                    if (this.newImage) {
                        if (this.smartphoneMainImage && this.tabletMainImage) {
                            this.errImages = false
                            this.formData.append('activityOtherFolderId', this.$route.params.id)
                            this.formData.append('title', this.activity.title || '')


                            if (this.transitionType == 'deeplink') {
                                this.formData.append('appSectionKey', this.activity.appSectionKey)
                                this.formData.append('transitionType', this.transitionType)
                            }
                            if (this.transitionType == 'file') {
                                this.formData.append('file', this.activity.transitionFile || '')
                                this.formData.append('transitionType', this.transitionType)
                            }
                            if (this.transitionType == 'url') {
                                this.formData.append('transitionType', this.transitionType)
                                this.formData.append('path', this.activity.path || '')
                                this.formData.append('isWebView', this.activity.isWebView)
                            }
                            if (this.transitionType == 'event') {
                                this.formData.append('transitionType', 'deeplink')
                                this.formData.append('appSectionKey', 'events')
                                this.formData.append('path', this.activity.path || '')
                            }

                            this.formData.append('originalImage', this.newImage || null)




                            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/activity/other/folder/block', this.formData, {
                                headers: {
                                    'authorization': this.$store.getters.adminPanelHeaderAuth
                                }
                            })
                                .then(() => {
                                    this.$router.push({ name: 'DetailFolderOther', params: { id: this.$route.params.id } })


                                })
                                .catch(err => {
                                    this.$store.commit('errorSet', true)
                                    this.$store.commit('errorTextSet', err)
                                })

                        }
                        else {
                            this.errImages = true
                        }
                    }
                    else {
                        this.errImagesMain = true
                    }


                }


            }

        },
        getEvents() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/event/list', {},
                {
                    headers: {
                        'authorization': this.$store.getters.adminPanelHeaderAuth
                    }
                })
                .then(res => {

                    this.events = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
    },
    created() {
        this.getEvents()
        this.getAppSections()
    },

    watch: {
        newImage() {
            if (this.newImage) {
                this.errImagesMain = false
            }
        },
        transitionType() {
            this.activity.path = null
        }


    }
}
</script>
<style lang="scss" scoped>
.switch-label {
    font-size: 16px;

    margin-bottom: 2px;
}

.container-main {
    box-sizing: border-box;

    padding: 40px !important;

    .container-main-header-button {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
            font-size: 28px;
            font-weight: 400;
            margin-left: 16px;
        }
    }

    .container-block {
        width: 50%;
        margin-bottom: 20px;

        .container-block-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;

        }

        .container-block-gallery-button {
            text-decoration: underline;
            color: #1064DD;
            font-size: 18px;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 20px;
        }

        .table-img {
            // width: 62px;
            height: 38px;
            object-fit: contain;
        }

        .container-main-checkbox {
            border: 1px solid rgb(224, 224, 224);
            border-radius: 4px;
            padding-top: 20px;
            padding-left: 12px;
            margin-top: 0px !important;

        }

        .container-block-file-preview {
            width: 47%;
            height: 56px;
            display: flex;
            align-items: center;




        }
    }

    .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
    }

}

.dialog-tablet-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    img {
        width: 658;
        height: 192;
    }
}
</style>